var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Heading", {
        attrs: {
          title: _vm.$t("account_activate_header"),
          routeName: "vignette",
        },
      }),
      _c(
        "div",
        { staticClass: "container pb-4" },
        [
          _c(
            "div",
            {
              staticClass: "text-center alert",
              class: {
                "alert-success": _vm.status == 1,
                "alert-info": _vm.status == 0,
                "alert-danger": _vm.status == -1,
              },
            },
            [
              !_vm.status
                ? _c("van-loading", [_vm._v(_vm._s(_vm.message))])
                : _vm._e(),
              _vm.status ? [_vm._v(" " + _vm._s(_vm.message) + " ")] : _vm._e(),
            ],
            2
          ),
          _vm.status > 0
            ? [_c("LoginComponent", { attrs: { "hide-socials": true } })]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }